import React from "react";
import { TextInput, View, StyleSheet } from "react-native";

import { MaterialCommunityIcons } from "@expo/vector-icons";

import config from "../config/config";

function AppTextInput({ icon, error, width = config.sizes.appTextInputWidth, borderColor, ...otherProps }) {
    return (
        <View style={[styles.container, { width, borderColor: config.colors.green }]}>
            {icon && <MaterialCommunityIcons name={icon} size={30} color={config.colors.tertiary} style={styles.icon} />}
            <TextInput style={config.text} {...otherProps} />
            {typeof error == "undefined" ? (
                <MaterialCommunityIcons name={"check"} size={30} color={config.colors.green} />
            ) : (
                <MaterialCommunityIcons name={"close"} size={30} color={config.colors.danger} />
            )}
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: config.colors.white,
        borderRadius: 25,
        flexDirection: "row",
        alignItems: "center",
        alignSelf: "center",
        marginBottom: 20,
        padding: 20,
    },
    icon: {
        paddingRight: 10,
    },
});

export default AppTextInput;
